import PublicDashboardCardTable from "../../Dashboard/Components/CardTable";

function PublicDashboardSettingsTransactions() {
  return (
    <PublicDashboardCardTable />
  );
}

export default PublicDashboardSettingsTransactions;